<template>
  <div style="background-color: #2A3042;">
    <main>
      <div class="container-fluid main-content">
        <slot />
      </div>
    </main>
    <Footer />
  </div>
</template>

<script>
import Footer from "../footer";

/**
 * Vertical layout
 */
export default {
  components: { Footer },
};
</script>
